"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";

const NAMESPACE = "new-aluminum-extrusion";
const IMAGE_BASE = "/image/new-version/more/AluminumExtrusion";

export default function HowAluminumExtrusionWorks() {
	const t = useTranslations(NAMESPACE);

	return (
		<section className="bg-[#ffffff] py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<div className="grid items-start gap-8 lg:grid-cols-[5fr_4fr] lg:gap-12">
					<div>
						<div className="relative mb-6 aspect-[16/6] w-full overflow-hidden border border-[#cecece] bg-white sm:mb-8">
							<Image
								src={`${IMAGE_BASE}/how-does-aluminum-extrusion-work.webp`}
								alt={t("howWorksImageAlt")}
								fill
								className="object-contain"
								sizes="(max-width: 1024px) 100vw, 55vw"
							/>
						</div>
						<div className="space-y-6 text-sm leading-relaxed text-black md:text-base md:leading-[1.8]">
							<p>{t("howWorksPressureDesc")}</p>
							<p>{t("howWorksCoolingDesc")}</p>
						</div>
					</div>

					<div>
						<h2 className="mb-6 text-2xl font-bold leading-tight text-black sm:text-[30px] md:text-4xl">
							{t("howWorksTitle")}
						</h2>
						<div className="space-y-6 text-sm leading-relaxed text-black md:text-base md:leading-[1.8]">
							<p>{t("howWorksIntro")}</p>
							<p>
								<strong className="font-bold">{t("howWorksHotTitle")}</strong> {t("howWorksHotDesc")}
							</p>
							<p>
								<strong className="font-bold">{t("howWorksColdTitle")}</strong> {t("howWorksColdDesc")}
							</p>
							<p>
								{t("howWorksHotProcessDescBefore")}
								<strong className="font-bold">{t("howWorksHotProcessDescBold")}</strong>
								{t("howWorksHotProcessDescAfter")}
							</p>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}
